import React from 'react';

import { Loader2, AlertCircle } from 'lucide-react';

interface ModalFooterProps {
  onCancel: () => void;
  onSave: () => void;
  isLoading: boolean;
  hasUnassignedCitations: boolean;
}

const ModalFooter: React.FC<ModalFooterProps> = ({
  onCancel,
  onSave,
  isLoading,
  hasUnassignedCitations,
}) => {
  return (
    <div className="border-t border-gray-200 px-6 py-4">
      <div className="flex items-center justify-end">
        {/* Action Buttons */}
        <div className="flex items-center gap-3">
          {hasUnassignedCitations && (
            <div className="flex items-center gap-1 text-red-600">
              <AlertCircle className="size-4" />
              <span className="text-sm font-medium">All citations must be assigned before saving</span>
            </div>
          )}
          <button
            type="button"
            onClick={onCancel}
            disabled={isLoading}
            className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onSave}
            disabled={isLoading || hasUnassignedCitations}
            className="flex items-center gap-2 rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {isLoading && <Loader2 className="size-4 animate-spin" />}
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalFooter;
